import { FC } from 'react';
import './AdSkeleton.scss';
import SkeletonImage from '@pages/Root/components/skeletons/SkeletonImage/SkeletonImage.tsx';
import { DEFAULT_AD_HEIGHT } from '@moment/shared-code/ad-utils.tsx';

interface AdSkeletonProps {
  height?: number;
}

const AdSkeleton: FC<AdSkeletonProps> = ({ height }) => {
  // Use a default height if none is provided, to keep existing behavior for feed ads.
  const style = { height: `${height || DEFAULT_AD_HEIGHT}px` };
  return (
    <div className="ad-skeleton" style={style}>
      <SkeletonImage />
    </div>
  );
};

export default AdSkeleton;
